module.exports = __webpack_public_path__ + "static/media/loader_black.d4f3eb2b.svg";